// ============================================================
// AppPieChart Component
// ============================================================

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip as RechartsTooltip,
  Legend,
} from 'recharts';
import { tokens } from '@/theme/tokens';

const DEFAULT_COLORS = [
  tokens.colors.primary.main,
  tokens.colors.secondary.main,
  tokens.colors.success.main,
  tokens.colors.warning.main,
];

export function AppPieChart({ data, dataKey = 'value', nameKey = 'name', colors = DEFAULT_COLORS }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          paddingAngle={5}
          dataKey={dataKey}
          nameKey={nameKey}
          stroke="none"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <RechartsTooltip
          contentStyle={{
            backgroundColor: tokens.colors.card,
            borderRadius: tokens.radius.md,
            border: `1px solid ${tokens.colors.border}`,
            boxShadow: tokens.shadows.md,
          }}
        />
        <Legend iconType="circle" wrapperStyle={{ fontSize: '12px' }} />
      </PieChart>
    </ResponsiveContainer>
  );
}
